

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import './ProgramsPage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function ProgramsPage() {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeCategory, setActiveCategory] = useState('All');
//   const [programsData, setProgramsData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Helper function to map DB program_type to UI filter categories & themes
// // Helper function to map program types to UI filters
//   const getCategoryTheme = (typeStr) => {
//     const type = typeStr ? typeStr.toUpperCase() : '';
//     if (type.includes('UNDER-GRADUATE') || type === 'UG') {
//       return { type: 'UG', typeLabel: 'UG', themeClass: 'theme-ug' };
//     } else if (type.includes('POST-GRADUATE') || type === 'PG') {
//       return { type: 'PG', typeLabel: 'PG', themeClass: 'theme-pg' };
//     } else if (type.includes('SECONDARY') || type.includes('HSC') || type.includes('10TH') || type.includes('12TH') || type.includes('PUC')) {
//       return { type: 'School/PUC', typeLabel: 'School / PUC', themeClass: 'theme-school' };
//     } else if (type.includes('DIPLOMA')) {
//       return { type: 'Diploma', typeLabel: 'Diploma', themeClass: 'theme-dip' };
//     } else if (type.includes('CERTIFICATE')) {
//       return { type: 'Certificate', typeLabel: 'Certificate', themeClass: 'theme-cert' };
//     }
//     return { type: 'UG', typeLabel: 'UG', themeClass: 'theme-ug' };
//   };

//   // Add expandable card state to view syllabus/documents
//   const [expandedCourseId, setExpandedCourseId] = useState(null);

//   const toggleExpand = (id) => {
//     setExpandedCourseId(expandedCourseId === id ? null : id);
//   };

//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch('https://metapi.emedhatechnologies.com/api/students/all-details');
//         const result = await response.json();

//         if (result.success) {
//           const formattedData = result.data.map((course) => {
//             const { type, typeLabel, themeClass } = getCategoryTheme(course.program_type);
//             const dur = parseInt(course.minimum_duration, 10);
//             const durationText = dur >= 1 ? `${dur} Year${dur > 1 ? 's' : ''}` : `${course.minimum_duration} Months`;

//             return {
//               id: course.id,
//               code: course.course_code,
//               title: course.course_name,
//               type: type,
//               typeLabel: typeLabel,
//               duration: durationText,
//               eligibility: course.eligibility || 'As per University Norms',
//               medium: course.course_medium || 'English Medium',
//               structureType: course.structure_type || 'Semester',
//               assignmentMarks: course.assignment_marks || 'N/A',
//               syllabus: course.syllabus || [],
//               requiredDocuments: course.required_documents || [],
//               semesters: course.semesters || [],
//               themeClass: themeClass
//             };
//           });

//           setProgramsData(formattedData);
//         }
//       } catch (error) {
//         console.error('Failed to fetch courses from API:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCourses();
//   }, []);

//   const categories = ['All', 'UG', 'PG', 'School/PUC', 'Diploma', 'Certificate'];

//   // Fetch courses from Express API
//   // useEffect(() => {
//   //   const fetchCourses = async () => {
//   //     try {
//   //       const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
//   //       const result = await response.json();

//   //       if (result.success) {
//   //         const formattedData = result.data.map((course) => {
//   //           const { type, typeLabel, themeClass } = getCategoryTheme(course.program_type);
            
//   //           // Format duration string
//   //           const dur = parseInt(course.minimum_duration);
//   //           const durationText = dur >= 1 ? `${dur} Year${dur > 1 ? 's' : ''}` : `${course.minimum_duration} Months`;

//   //           // Calculate fee metrics
//   //           const annualFeeNum = parseFloat(course.total_course_fee) || 0;
//   //           const years = dur >= 1 ? dur : 1;
//   //           const totalFeeNum = annualFeeNum ;

//   //           return {
//   //             id: course.id,
//   //             code: course.course_code,
//   //             title: course.course_name,
//   //             type: type,
//   //             typeLabel: typeLabel,
//   //             duration: durationText,
//   //             eligibility: course.eligibility || 'As per University Norms',
//   //             medium: course.course_medium,
//   //             annualFee: `₹${annualFeeNum.toLocaleString('en-IN')}`,
//   //             totalFee: `₹${totalFeeNum.toLocaleString('en-IN')}`,
//   //             themeClass: themeClass
//   //           };
//   //         });

//   //         setProgramsData(formattedData);
//   //       }
//   //     } catch (error) {
//   //       console.error('Failed to fetch courses from API:', error);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchCourses();
//   // }, []);

//   // Filtering Logic based on Search Term & Active Category
//   const filteredPrograms = programsData.filter((item) => {
//     const matchesSearch =
//       item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.eligibility.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesCategory =
//       activeCategory === 'All' || item.type === activeCategory;

//     return matchesSearch && matchesCategory;
//   });

//   // const categories = ['All', 'UG', 'PG', 'Diploma', 'Certificate'];

//   return (
//     <>
//       <Navbar />
//       <div className="programs-page-wrapper">
        
//         {/* 1. Header Banner */}
//         <section className="programs-hero-banner">
//           <div className="banner-inner-container">
//             <nav className="breadcrumb-nav">
//               <Link to="/" className="breadcrumb-link">Home</Link> / <span>Programs</span>
//             </nav>
//             <h1>Programs Offered</h1>
//             <p>Academic Year 2025–26 | UG, PG, Diploma &amp; Certificate Programs</p>
//           </div>
//         </section>

//         {/* 2. Filter & Search Control Section */}
//         <section className="programs-control-section">
//           <div className="programs-container">
            
//             <div className="filter-bar-wrapper">
//               {/* Search Input */}
//               <div className="search-input-box">
//                 <span className="search-icon">🔍</span>
//                 <input
//                   type="text"
//                   placeholder="Search programs..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>

//               {/* Category Filter Pills */}
//               <div className="category-filter-group">
//                 {categories.map((cat) => (
//                   <button
//                     key={cat}
//                     className={`filter-pill ${activeCategory === cat ? 'active-pill' : ''}`}
//                     onClick={() => setActiveCategory(cat)}
//                   >
//                     {cat}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Results Count Metadata */}
//             <div className="results-count-text">
//               {loading ? 'Loading programs...' : `${filteredPrograms.length} programs found`}
//             </div>

//           </div>
//         </section>

//         {/* 3. Programs Cards Grid */}
//         <section className="programs-grid-section">
//           <div className="programs-container">
            
//             {loading ? (
//               <div className="no-results-box">
//                 <h3>Loading programs, please wait...</h3>
//               </div>
//             ) : filteredPrograms.length > 0 ? (
//              <div className="programs-cards-grid">
//   {filteredPrograms.map((program) => {
//     const isExpanded = expandedCourseId === program.id;

//     return (
//       <div key={program.id} className={`program-card ${program.themeClass}`}>
//         <div className="card-top-accent"></div>

//         <div className="card-body-content">
//           <div className="card-header-row">
//             <div>
//               <span className="course-code-tag">{program.code}</span>
//               <h3 className="program-title">{program.title}</h3>
//             </div>
//             <span className="type-badge">{program.typeLabel}</span>
//           </div>

//           {/* Academic Specifications (No Fees) */}
//           <div className="spec-details-list">
//             <div className="spec-row">
//               <span className="spec-label">Duration:</span>
//               <span className="spec-val font-semibold">{program.duration}</span>
//             </div>
//             <div className="spec-row">
//               <span className="spec-label">Medium:</span>
//               <span className="spec-val">{program.medium}</span>
//             </div>
//             <div className="spec-row">
//               <span className="spec-label">Pattern:</span>
//               <span className="spec-val">{program.structureType}</span>
//             </div>
//             <div className="spec-row">
//               <span className="spec-label">Eligibility:</span>
//               <span className="spec-val align-right">{program.eligibility}</span>
//             </div>
//             {program.assignmentMarks !== 'N/A' && (
//               <div className="spec-row">
//                 <span className="spec-label">Internal Marks:</span>
//                 <span className="spec-val">{program.assignmentMarks} Marks</span>
//               </div>
//             )}
//           </div>

//           {/* Accordion Toggle for Syllabus & Documents */}
//           {(program.syllabus.length > 0 || program.requiredDocuments.length > 0) && (
//             <button 
//               type="button" 
//               className="btn-toggle-curriculum"
//               onClick={() => toggleExpand(program.id)}
//             >
//               {isExpanded ? 'Hide Academic Details ▲' : 'View Syllabus & Required Docs ▼'}
//             </button>
//           )}

//           {/* Expanded Section */}
//           {isExpanded && (
//             <div className="expanded-course-info">
//               {/* Syllabus Breakdown */}
//               {program.syllabus.length > 0 && (
//                 <div className="syllabus-block">
//                   <h4>Curriculum Structure:</h4>
//                   {program.syllabus.map((termObj, tIdx) => (
//                     <div key={tIdx} className="term-group">
//                       <strong>{termObj.term}:</strong>
//                       <ul>
//                         {termObj.papers && termObj.papers.map((paper, pIdx) => (
//                           <li key={pIdx}>{paper}</li>
//                         ))}
//                       </ul>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Required Documents */}
//               {program.requiredDocuments.length > 0 && (
//                 <div className="docs-block">
//                   <h4>Documents Checklist:</h4>
//                   <ul className="docs-sublist">
//                     {program.requiredDocuments.map((doc, dIdx) => (
//                       <li key={dIdx}>✓ {doc}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Action Buttons */}
//           <div className="card-footer-actions">
//             <Link to="/contact-enquiry" className="btn-card-apply">
//               Apply Now <span className="arrow-icon">➔</span>
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   })}
// </div>
//             ) : (
//               <div className="no-results-box">
//                 <h3>No programs matched your search criteria.</h3>
//                 <p>Try clearing your search input or switching filter categories.</p>
//               </div>
//             )}

//           </div>
//         </section>

//       </div>
//       <FooterSection />
//     </>
//   );
// }

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProgramsPage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

export default function ProgramsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const [programsData, setProgramsData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Expanded card tracking & active sub-tab (syllabus | schedule | documents)
  const [expandedCourseId, setExpandedCourseId] = useState(null);
  const [activeDrawerTab, setActiveDrawerTab] = useState('syllabus');

  // Helper function to map program types to UI filters & color accents
  const getCategoryTheme = (typeStr) => {
    const type = typeStr ? typeStr.toUpperCase() : '';
    if (type.includes('UNDER-GRADUATE') || type === 'UG') {
      return { type: 'UG', typeLabel: 'Undergraduate (UG)', themeClass: 'theme-ug' };
    } else if (type.includes('POST-GRADUATE') || type === 'PG') {
      return { type: 'PG', typeLabel: 'Postgraduate (PG)', themeClass: 'theme-pg' };
    } else if (
      type.includes('SECONDARY') ||
      type.includes('HSC') ||
      type.includes('10TH') ||
      type.includes('12TH') ||
      type.includes('PUC')
    ) {
      return { type: 'School/PUC', typeLabel: 'School / PUC', themeClass: 'theme-school' };
    } else if (type.includes('DIPLOMA')) {
      return { type: 'Diploma', typeLabel: 'Diploma Course', themeClass: 'theme-dip' };
    } else if (type.includes('CERTIFICATE')) {
      return { type: 'Certificate', typeLabel: 'Certificate Course', themeClass: 'theme-cert' };
    }
    return { type: 'UG', typeLabel: 'UG Degree', themeClass: 'theme-ug' };
  };

  const toggleExpand = (id) => {
    if (expandedCourseId === id) {
      setExpandedCourseId(null);
    } else {
      setExpandedCourseId(id);
      setActiveDrawerTab('syllabus'); // default tab on open
    }
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/students/all-details');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          const formattedData = result.data.map((course) => {
            const { type, typeLabel, themeClass } = getCategoryTheme(course.program_type);
            const dur = parseInt(course.minimum_duration, 10);
            const durationText = dur >= 1 ? `${dur} Year${dur > 1 ? 's' : ''}` : `${course.minimum_duration} Months`;

            return {
              id: course.id,
              code: course.course_code,
              title: course.course_name,
              type: type,
              typeLabel: typeLabel,
              duration: durationText,
              eligibility: course.eligibility || 'As per University Norms',
              medium: course.course_medium || 'English Medium',
              structureType: course.structure_type || 'Semester',
              assignmentMarks: course.assignment_marks || null,
              syllabus: Array.isArray(course.syllabus) ? course.syllabus : [],
              requiredDocuments: Array.isArray(course.required_documents) ? course.required_documents : [],
              semesters: Array.isArray(course.semesters) ? course.semesters : [],
              themeClass: themeClass
            };
          });

          setProgramsData(formattedData);
        }
      } catch (error) {
        console.error('Failed to fetch courses from API:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const categories = ['All', 'UG', 'PG', 'School/PUC', 'Diploma', 'Certificate'];

  // Filtering Logic
  const filteredPrograms = programsData.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.eligibility.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory = activeCategory === 'All' || item.type === activeCategory;

    return matchesSearch && matchesCategory;
  });

  return (
    <>
      <Navbar />
      <div className="programs-page-wrapper">
        
        {/* 1. Header Banner */}
        <section className="programs-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Academic Programs</span>
            </nav>
            <h1>Academic Programs &amp; Curriculum</h1>
            <p>Explore recognized degree, diploma, and certification courses with transparent curriculum schedules.</p>
          </div>
        </section>

        {/* 2. Controls & Search Bar */}
     {/* 2. Filter & Search Control Section */}
<section className="programs-control-section">
  <div className="programs-container">
    <div className="filter-bar-wrapper">
      
      {/* Search Input */}
      <div className="search-input-box">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search courses, codes, eligibility..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button className="clear-btn" onClick={() => setSearchTerm('')}>✕</button>
        )}
      </div>

      {/* Responsive Horizontal Scroll Category Filter */}
      <div className="category-scroll-container">
        <div className="category-filter-group">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-pill ${activeCategory === cat ? 'active-pill' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

    </div>

    {/* Dynamic Results Counter */}
    <div className="results-count-text">
      {loading ? 'Loading programs...' : `Showing ${filteredPrograms.length} academic program(s)`}
    </div>
  </div>
</section>

        {/* 3. Programs Cards Grid */}
        <section className="programs-grid-section">
          <div className="programs-container">
            
            {loading ? (
              <div className="program-loading-state">
                <div className="program-spinner"></div>
                <p>Loading course curricula and schedules...</p>
              </div>
            ) : filteredPrograms.length > 0 ? (
              <div className="programs-cards-grid">
                {filteredPrograms.map((program) => {
                  const isExpanded = expandedCourseId === program.id;

                  return (
                    <div key={program.id} className={`program-card ${program.themeClass} ${isExpanded ? 'card-is-expanded' : ''}`}>
                      
                      {/* Top Accent Strip */}
                      <div className="card-top-accent"></div>

                      <div className="card-body-content">
                        
                        {/* Header Row */}
                        <div className="card-header-row">
                          <span className="course-code-badge">{program.code}</span>
                          <span className="type-badge">{program.typeLabel}</span>
                        </div>

                        <h3 className="program-title">{program.title}</h3>

                        {/* Highlighted Meta Badges Row */}
                        <div className="program-badge-pills">
                          <span className="pill-metric">
                            <span className="icon">⏳</span> {program.duration}
                          </span>
                          <span className="pill-metric">
                            <span className="icon">🌐</span> {program.medium}
                          </span>
                          <span className="pill-metric">
                            <span className="icon">📑</span> {program.structureType}
                          </span>
                        </div>

                        {/* Key Academic Specs */}
                        <div className="spec-details-list">
                          <div className="spec-row">
                            <span className="spec-label">Eligibility Criteria:</span>
                            <span className="spec-val eligibility-val">{program.eligibility}</span>
                          </div>
                          {program.assignmentMarks && (
                            <div className="spec-row">
                              <span className="spec-label">Internal Marks:</span>
                              <span className="spec-val font-semibold">{program.assignmentMarks} Marks</span>
                            </div>
                          )}
                        </div>

                        {/* Accordion Expand/Collapse Trigger */}
                        <button
                          type="button"
                          className={`btn-toggle-curriculum ${isExpanded ? 'active' : ''}`}
                          onClick={() => toggleExpand(program.id)}
                        >
                          <span>{isExpanded ? 'Collapse Academic Details' : 'View Syllabus, Exams & Docs'}</span>
                          <span className="toggle-chevron">{isExpanded ? '▲' : '▼'}</span>
                        </button>

                        {/* Interactive Drawer Section */}
                        {isExpanded && (
                          <div className="expanded-course-info">
                            
                            {/* Inner Sub-Navigation Tabs */}
                            <div className="drawer-tab-nav">
                              <button
                                className={`drawer-tab-btn ${activeDrawerTab === 'syllabus' ? 'tab-active' : ''}`}
                                onClick={() => setActiveDrawerTab('syllabus')}
                              >
                                📖 Syllabus ({program.syllabus.length})
                              </button>
                              
                              <button
                                className={`drawer-tab-btn ${activeDrawerTab === 'schedule' ? 'tab-active' : ''}`}
                                onClick={() => setActiveDrawerTab('schedule')}
                              >
                                🗓️ Exam Schedule ({program.semesters.length})
                              </button>

                              <button
                                className={`drawer-tab-btn ${activeDrawerTab === 'documents' ? 'tab-active' : ''}`}
                                onClick={() => setActiveDrawerTab('documents')}
                              >
                                📋 Documents ({program.requiredDocuments.length})
                              </button>
                            </div>

                            {/* Tab Pane 1: Syllabus */}
                            {activeDrawerTab === 'syllabus' && (
                              <div className="drawer-tab-pane">
                                {program.syllabus.length > 0 ? (
                                  <div className="syllabus-accordion-stack">
                                    {program.syllabus.map((termObj, tIdx) => (
                                      <div key={tIdx} className="syllabus-term-card">
                                        <div className="term-card-header">{termObj.term}</div>
                                        <ul className="term-papers-list">
                                          {termObj.papers && termObj.papers.map((paper, pIdx) => (
                                            <li key={pIdx}>
                                              <span className="paper-bullet">•</span> {paper}
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <p className="drawer-empty-msg">Detailed syllabus will be provided in the course handbook.</p>
                                )}
                              </div>
                            )}

                            {/* Tab Pane 2: Semester & Exam Schedule */}
                            {activeDrawerTab === 'schedule' && (
                              <div className="drawer-tab-pane">
                                {program.semesters.length > 0 ? (
                                  <div className="schedule-table-wrapper">
                                    <table className="schedule-table">
                                      <thead>
                                        <tr>
                                          <th>Term / Semester</th>
                                          <th>Exam Schedule</th>
                                          <th>Assignment Window</th>
                                          <th>Results Timeline</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {program.semesters.map((sem, sIdx) => (
                                          <tr key={sIdx}>
                                            <td className="font-semibold text-primary">{sem.term_label || `Term ${sIdx + 1}`}</td>
                                            <td>{sem.exam_schedule_text || 'May / Dec'}</td>
                                            <td>{sem.assignment_duration || '10 Days'}</td>
                                            <td>{sem.results_timeline_text || '45 Days'}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <p className="drawer-empty-msg">Exam timetables follow standard university academic session calendars.</p>
                                )}
                              </div>
                            )}

                            {/* Tab Pane 3: Required Documents */}
                            {activeDrawerTab === 'documents' && (
                              <div className="drawer-tab-pane">
                                {program.requiredDocuments.length > 0 ? (
                                  <div className="docs-checklist-grid">
                                    {program.requiredDocuments.map((doc, dIdx) => (
                                      <div key={dIdx} className="doc-check-item">
                                        <span className="doc-check-icon">✓</span>
                                        <span>{doc}</span>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <p className="drawer-empty-msg">Standard ID, address proof, and qualifying marksheets required.</p>
                                )}
                              </div>
                            )}

                          </div>
                        )}

                        {/* Action Footer */}
                        <div className="card-footer-actions">
                          <Link to="/contact-enquiry" className="btn-card-apply">
                            Apply for this Course <span className="arrow-icon">➔</span>
                          </Link>
                        </div>

                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="no-results-box">
                <h3>No academic programs match your filters.</h3>
                <p>Try searching for a different keyword or switch the category filter tab to 'All'.</p>
              </div>
            )}

          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}